var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"type":"file"},domProps:{"value":_vm.value},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }